document.addEventListener('DOMContentLoaded', function () {
  var popup = document.getElementById('calendly-popup');
  if (!popup) return;

  function open(e){ if(e) e.preventDefault();
    popup.classList.add('is-open'); popup.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden'; }
  function close(){ popup.classList.remove('is-open'); popup.setAttribute('aria-hidden','true');
    document.body.style.overflow=''; }

  document.querySelectorAll('.js-open-calendly').forEach(function(b){ b.addEventListener('click', open); });
  document.querySelectorAll('.js-close-calendly').forEach(function(b){ b.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
});